import React, { useEffect, useRef, useState } from "react";

const DURATION = 1100;
const easeOut = (t) => 1 - Math.pow(1 - t, 3);

/**
 * Zählt den Zahlenteil eines Werts hoch, sobald er ins Bild kommt.
 * Werte ohne führende Ziffer ("MBA") werden unverändert ausgegeben,
 * ebenso bei reduzierter Bewegung.
 */
export const CountUp = ({ value }) => {
  const match = /^(\d+)(.*)$/.exec(value);
  const target = match ? Number(match[1]) : null;
  const suffix = match ? match[2] : "";

  const ref = useRef(null);
  const [shown, setShown] = useState(0);

  useEffect(() => {
    if (target === null) return undefined;

    const el = ref.current;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!el || reduced || typeof IntersectionObserver === "undefined") {
      setShown(target);
      return undefined;
    }

    let frame;
    const run = () => {
      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / DURATION, 1);
        setShown(Math.round(target * easeOut(progress)));
        if (progress < 1) frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          run();
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(el);

    return () => {
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
    };
  }, [target]);

  if (target === null) return value;

  return (
    <span ref={ref}>
      {shown}
      {suffix}
    </span>
  );
};

export default CountUp;
